import type { GlbHierarchyNode } from '../loaders/glb'

export type GlbNodeSemanticKind = 'assembly' | 'part' | 'unknown'
export type GlbNodeIconType = 'assembly' | 'part' | 'body' | 'group'

export function resolveGlbHierarchyNodeSemanticKind(node: GlbHierarchyNode): GlbNodeSemanticKind {
  const semanticKind = node.meta?.semanticKind
  if (semanticKind === 'assembly' || semanticKind === 'part') {
    return semanticKind
  }
  return 'unknown'
}

export function resolveGlbHierarchyNodeIconType(node: GlbHierarchyNode): GlbNodeIconType {
  if (node.nodeType === 'Body') {
    return 'body'
  }
  const semanticKind = resolveGlbHierarchyNodeSemanticKind(node)
  if (semanticKind === 'assembly') {
    return 'assembly'
  }
  if (semanticKind === 'part') {
    return 'part'
  }
  return 'group'
}
